export const TransformStyle: any = {
    name: 'Transform',
    open: false,
    buildProps: ['transition', 'perspective', 'transform'],
}
